import { createPlugin } from '@backstage/core-plugin-api';

export default createPlugin({
    id: 'home-page',
    featureFlags: [{ name: 'enable-home-page' }],
});

